import React, { Component } from "react";
import {
  Breadcrumb
} from "react-bootstrap";

const styles = {
  tab: {
    color: "black"
  }
};

const breadcrumbInstance = (
  <Breadcrumb>
    <Breadcrumb.Item id="name" style={styles.tab} href="/" pullLeft>
      Edmond O'Connell
    </Breadcrumb.Item>
    <Breadcrumb.Item style={styles.tab} href="/projects">
      Projects
    </Breadcrumb.Item>
    <Breadcrumb.Item style={styles.tab} href="/contact" pullRight>
      Contact
    </Breadcrumb.Item>
    <Breadcrumb.Item style={styles.tab} href="/main" pullRight>
      Main
    </Breadcrumb.Item>
  </Breadcrumb>
);

export default class Header extends Component {
  render() {
    return <div className="headerNav">{breadcrumbInstance}</div>;
  }
}
